import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Panel from '../../../components/Panel';
import HistoricalData from '../../../components/HistoricalData';
import { Heart as HeartIcon } from '../../../icons';
import { createHealthHistory } from './mocks';

let interval = 0;
const styles = () => ({
  title: {
    display: 'block',
  },
  healthTimeWrapper: {
    position: 'absolute',
    color: '#333',
    fontWeight: '400',
    fontSize: '14px',
    top: 0,
    right: 0,
    margin: 0,
    flexFlow: 'column',
    lineHeight: '1.25',
    padding: '6px 23px',
    cursor: 'pointer',
  },
  healthTimeAgo: {
    display: 'block',
  },
  active: {
    color: '#1682bc',
    '&:hover': {
      backgroundColor: '#ddd',
    },
  },
});

class HistoricalHealthContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { filteredServers: [], timeAgo: timeAgoConfig[0] };
    this.handleDropdownSelect = this.handleDropdownSelect.bind(this);
    this.handleRemoveFilter = this.handleRemoveFilter.bind(this);
  }

  getTooltipData(d) {
    const date = d.time_bucket;
    const futureDate = new Date(date.getTime() + (interval * 60000));
    const parsedDate = `${(`0${date.getMonth() + 1}`).slice(-2)}/${
      (`0${date.getDate()}`).slice(-2)}/${
      date.getFullYear()} ${
      (`0${date.getHours()}`).slice(-2)}:${
      (`0${date.getMinutes()}`).slice(-2)} - ${
      (`0${futureDate.getHours()}`).slice(-2)}:${
      (`0${futureDate.getMinutes()}`).slice(-2)} GMT-0400 (Eastern Time)`;
    const tooltipHtml = `
    <div>${parsedDate}</div>
    `;
    return tooltipHtml;
  }

  getBarColors(value) {
    if (value === 0) {
      return '#DC2620';
    }
    if (value === 1) {
      return '#86C35D';
    }

    return '#FF9E00';
  }

  handleDropdownSelect(selectedItem) {
    const { filteredServers } = this.state;
    const isExist = !!filteredServers.find(item => item.code === selectedItem.code);
    isExist ? null : filteredServers.push(selectedItem);
    this.setState({ filteredServers });
  }

  handleRemoveFilter(selectedItem) {
    let { filteredServers } = this.state;
    filteredServers = filteredServers.filter(item => item.code !== selectedItem.code);
    this.setState({ filteredServers });
  }

  handleTimeAgo(timeAgo) {
    this.setState({ timeAgo });
  }

  getTransformedData(records, timeAgo, service) {
    switch (timeAgo.value) {
      case 'day':
        interval = 15;
        break;
      case 'three_day':
        interval = 60;
        break;
      case 'week':
        interval = 120;
        break;
      default:
        interval = 120;
    }
    const totalRecords = (records.length && records[0].servertype === service.code)
      ? records : [];
    const servertype = service.description;
    const healthHistory = createHealthHistory(interval);
    healthHistory.map((item, i) => { healthHistory[i].servertype = servertype; });
    for (let i = 0; i < totalRecords.length; i++) {
      const thisTime = new Date(totalRecords[i].time_bucket);
      const bucket = new Date(Math.floor(thisTime.getTime() / (interval * 60000)) * (interval * 60000));
      if (totalRecords[i].time_bucket > healthHistory[0].time_bucket.toISOString()) {
        healthHistory.find(v => v.time_bucket.toString() === bucket.toString()).avg = totalRecords[i].avg;
      }
    }
    const transformedRecords = healthHistory;
    transformedRecords.sort((a, b) => {
      a = new Date(a.time_bucket);
      b = new Date(b.time_bucket);
      return a > b ? 1 : a < b ? -1 : 0;
    });
    return transformedRecords;
  }

  render() {
    const { classes } = this.props;
    const { active } = classes;
    const healthTime = (
      <div className={classes.healthTimeWrapper}>
        {
          timeAgoConfig.map((item, i) => <div key={i} className={(this.state.timeAgo.label === item.label) ? classes.active : ''} onClick={() => this.handleTimeAgo(item)}>{item.label}</div>)
        }
      </div>
    );
    return (
      <div>
        <Panel
          id="irisPlatformStatusPanel"
          title={(
            <div>
              Iris Platform Status
              <span>{healthTime}</span>
            </div>
          )}
          classes={{ title: classes.title }}
          avatar={<HeartIcon width="34" height="50" />}
        >
          <HistoricalData
            filteredServers={this.state.filteredServers}
            timeAgo={this.state.timeAgo}
            onSelect={this.handleDropdownSelect}
            getTooltipData={this.getTooltipData}
            getBarColors={this.getBarColors}
            getTransformedData={this.getTransformedData}
            handleDelete={this.handleRemoveFilter}
          />
        </Panel>
      </div>
    );
  }
}


export default withStyles(styles)(HistoricalHealthContainer);

const timeAgoConfig = [
  {
    label: '24 Hours',
    value: 'day',
  },
  {
    label: '72 Hours',
    value: 'three_day',
  },
  {
    label: '7 days',
    value: 'week',
  },
];
